import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { DropdownItem } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  tenant: ITenant;
}

const MainNavBarSwitchModeLinks: React.FC<IParams> = ({tenant}) => {
  const rootStore = useContext(RootStoreContext);
  const { isOfflineModeEnabled, isOnline } = rootStore.commonStore;
  const [t] = useTranslation(["nativeapp"], translationHookOptions);

  return (
    <>
      {isOfflineModeEnabled ? (
        <DropdownItem disabled={!isOnline} tag="a" href={tenant.path}>
          {isOnline ? t("navbar_dropdown_online_mode") : t("navbar_dropdown_no_network")}
        </DropdownItem>
      ) : (
        <DropdownItem tag="a" href={`/player/offline${tenant.path}`}>
          {t("navbar_dropdown_offline_mode")}
        </DropdownItem>
      )}
      <DropdownItem divider />
    </>
  );
};

export default observer(MainNavBarSwitchModeLinks);
